import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import validate, { emailSchema, nicknameSchema } from '../../../../support/services/validation';
import './styles.css';

function useSaveButton(remoteStates, sharedStates, commands, queries) {
  
  useEffect(() => {
    if (sharedStates.user.queriesChecked) {
      if (sharedStates.user.whatsappAvailable && sharedStates.user.nicknameAvailable && sharedStates.user.emailAvailable) {
        commands.edit.finishEdit();
        commands.user.resetSharedStates();
        const data ={
          email: sharedStates.user.data.email,
          firstName: sharedStates.user.data.firstName,
          lastName: sharedStates.user.data.lastName,
          whatsapp: sharedStates.user.data.whatsapp,
          cpf: sharedStates.user.data.cpf,
          userName: sharedStates.user.data.nickname,
          img: sharedStates.user.data.img === remoteStates.user?.imagesPaths[remoteStates.user?.imagesPaths.length - 1] ? null : sharedStates.user.data.img,
        };
        const {cpf, ...dataWithoutCPF} = data;
        commands.user.updateData(sharedStates?.user?.data?.cpf ? data : dataWithoutCPF );
      } else if (sharedStates.edit.isEditing) {
        if (!sharedStates.user.whatsappAvailable) toast('Whatsapp já utilizado por outro usuário!', { type: toast.TYPE.WARNING });
        else if (!sharedStates.user.nicknameAvailable) toast('Apelido já utilizado por outro usuário!', { type: toast.TYPE.WARNING });
        else if (!sharedStates.user.emailAvailable) toast('Email já utilizado por outro usuário!', { type: toast.TYPE.WARNING });
      }
    }
  }, [sharedStates.user.queriesChecked]);

  const successEdit = () =>{
    toast('Dados salvos!', { type: toast.TYPE.SUCCESS });
  };

  const handleSave = async () => {
    try {
      await validate(emailSchema, sharedStates.user.data.email);
      await validate(nicknameSchema, sharedStates.user.data.nickname);
    } catch (err) {
      return toast(err.message, { type: toast.TYPE.WARNING });
    }
    queries.checkWhatsapp(remoteStates.user.id);
    queries.checkEmail(remoteStates.user.id);
    queries.checkNickname(remoteStates.user.id);
  };

  return ({
    localStates: {
      
    },
    eventHandlers: {
      handleSave,
      successEdit,

    },
  });
}

export default function SaveButton(props) {
  const {
    remoteStates, sharedStates, commands, metaStates, queries,
  } = props;
  const { eventHandlers} = useSaveButton(remoteStates, sharedStates, commands, queries);

  useEffect(()=>{
    if(metaStates.isUpdated) eventHandlers.successEdit();
  },[metaStates.isUpdated]);

  if (!(sharedStates.edit.isEditing && !metaStates.isFetching)) return null;

  return (
    <div className="saveBarContent">
      <button onClick={metaStates.isUpdating ? ()=>{} : eventHandlers.handleSave} className="saveBar">
        <p className="saveBarText">{metaStates.isUpdating ? 'Salvando...' : 'Salvar'}</p>
      </button>
    </div>
  );
}
